export default [
  {
    value: "1",
    label:
      "Central - This code is used if the organization is a central type organization (no group exemption) of a National, Regional or Geographic grouping of organizations.",
  },
  {
    value: "2",
    label:
      "Intermediate - This code is used if the organization is an intermediate organization (no group exemption) of a National, Regional or Geographic grouping of organizations (such as a state headquarters of a national organization).",
  },
  {
    value: "3",
    label:
      "Independent - This code is used if the organization is an independent organization or an independent auxiliary (i.e., not affiliated with a National, Regional, or Geographic grouping of organizations).",
  },
  {
    value: "6",
    label:
      "Central - This code is used if the organization is a parent (group ruling) and is not a church or 501(c)(1) organization.",
  },
  {
    value: "7",
    label:
      "Intermediate  - This code is used if the organization is a group exemption intermediate organization of a National, Regional or Geographic grouping of organizations.",
  },
  {
    value: "8",
    label:
      "Central - This code is used if the organization is a parent (group ruling) and is a church or 501(c)(1) organization.",
  },
  {
    value: "9",
    label:
      "Subordinate  - This code is used if the organization is a subordinate in a group ruling.",
  },
];
